import { useHistory, useParams } from "react-router";
import { common_utils } from "../../../../../../common/common_utils";
import {
	PublicAvailabilityPoll,
	AvailabilityPollContent,
} from "../../../../time-finder/components/availability-poll";
import { trpc } from "../../../utils/trpc";
import { LoadingThrobber } from "../base_components/loading_throbber";
import { useUserContext } from "../hooks/use_user_context";
import MemberDisplayNameWithTooltip from "../member_display_name/member_display_name_with_tooltip";
import { DashboardUtils } from "../../../dashboard_utils";

export function TimeFinderView(props: { time_finder_id: string }) {
	const history = useHistory();
	const { server_id } = useParams<{ server_id: string }>();

	const mutation = trpc.time_finder.updateAvailability.useMutation({
		onSuccess: () => {
			history.go(0);
		},
	});

	const deleteMutation = trpc.time_finder.delete.useMutation({
		onSuccess: () => {
			history.push(
				common_utils.getTimeFinderURL({
					server_id: server_id,
					type: "base",
				})
			);
		},
	});

	const user = useUserContext();

	const time_finder_query = trpc.time_finder.getById.useQuery({
		id: props.time_finder_id,
		guild_id: server_id,
	});

	if (!time_finder_query.isSuccess) {
		return <LoadingThrobber />;
	}

	const handleEdit = () => {
		history.push(
			common_utils.getTimeFinderURL({
				server_id: server_id,
				type: "edit",
				instance_id: props.time_finder_id,
			})
		);
	};

	const handleDelete = async () => {
		const confirmation_result = await DashboardUtils.ShowDeleteConfirmAlert(
			<span>
				Are you sure you want to permanently delete time finder{" "}
				<span className="has-text-weight-bold">
					{time_finder_query.data.title}
				</span>
				?
			</span>
		);

		if (!confirmation_result.isConfirmed) {
			return;
		}

		deleteMutation.mutate({
			id: props.time_finder_id,
			guild_id: server_id,
		});
	};

	return (
		<AvailabilityPollContent
			time_finder_instance={time_finder_query.data}
			UserRenderer={UserRenderer}
			onSubmit={(opts) =>
				mutation.mutate({
					...opts,
					guild_id: server_id,
					id: props.time_finder_id,
				})
			}
			is_loading={mutation.isLoading || mutation.isSuccess}
			user_id={user.id}
			create_new_poll_link={common_utils.getTimeFinderURL({
				server_id,
				type: "create",
			})}
			is_editable={true}
			onEdit={handleEdit}
			onDelete={time_finder_query.data.can_delete ? handleDelete : undefined}
			is_deleting={deleteMutation.isLoading}
			is_on_dashboard={true}
		/>
	);
}

function UserRenderer(props: { user_id: string }) {
	return (
		<MemberDisplayNameWithTooltip user_id={props.user_id} include_avatar />
	);
}
